
import { TypedVue } from "@/store/types";
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { CandidateSummary, PARTICIPANT_TYPE_LABELS } from "./shared";
import HoverTip from "./HoverTip.vue";

// The pill next to a participant's name. Candidates get their Strong/Good/Limited match
// tag with a tooltip defining that level (MatchTag::Tooltip::<level> literals); managers
// and team members are not scored against the role, so they get a role pill instead.
@Component({ components: { HoverTip } })
export default class ParticipantTag extends TypedVue {
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ required: true })
  readonly summary!: CandidateSummary;

  @Prop({ default: false })
  readonly mini!: boolean;

  get typeLabel(): string {
    return PARTICIPANT_TYPE_LABELS[this.summary.participantType];
  }

  get tooltip(): string {
    return this.summary.isCandidate ? this.$t(`MatchTag::Tooltip::${this.summary.matchLevel}`).toString() : "";
  }
}
